const DeliveryAddressTypeConstant = {
  DEPARTURE: 'DEPARTURE',
  DELIVERY: 'DELIVERY',
  RETURN: 'RETURN'
}

export default DeliveryAddressTypeConstant
